/**
 * BetterAuth's reset endpoint throws `APIError("BAD_REQUEST",
 * { message: "INVALID_TOKEN" })`, but the wire serialization can surface
 * the enum in any of four fields depending on better-call config. Check
 * all four with case-sensitive exact match (BetterAuth uses uppercase enums).
 */
export function isInvalidToken(data: unknown): boolean {
  if (!data || typeof data !== 'object') return false;
  const d = data as Record<string, unknown>;
  const code = 'INVALID_TOKEN';
  return (
    d.message === code ||
    d.code === code ||
    d.error === code ||
    (typeof d.error === 'object' &&
      d.error !== null &&
      (d.error as Record<string, unknown>).code === code)
  );
}
